// Brand-aligned categorical palette (navy + cyan + complements).
// Deterministic by index so chart colors stay stable across renders.
// (The old implementation used Math.random() on every call, which made the
//  pie-chart segments flicker / change color on each re-render.)
const CATEGORICAL_PALETTE = [
  "#00187E", // primary navy
  "#00BECC", // accent cyan
  "#4C6FFF", // bright blue
  "#16A34A", // green
  "#F5A524", // amber
  "#9B6BFF", // violet
  "#FF6B9D", // pink
  "#00B6C6", // teal
  "#5A607F", // slate
  "#001563", // deep navy
];

export const getColor = (_palleteLength, idx) =>
  CATEGORICAL_PALETTE[idx % CATEGORICAL_PALETTE.length];

export const palette = CATEGORICAL_PALETTE;
